<div
  nz-row
  [nzGutter]="[0, 32]"
>
  <div nz-col [nzSpan]="24">
    <div nz-row [nzGutter]="[0, 8]">
      <div nz-col [nzSpan]="24">
        <h2
          i18n="@@OTPInput.Title.Text"
        > Richiesta autenticazione di secondo livello</h2>
      </div>
      <ng-container [ngSwitch]="selectedLevel2OtpGenerator">
        <div nz-col nzSpan="24" *ngSwitchCase="OtpDeliveryMethod.SMS">
          <p
            i18n="@@OTPInput.Sms.Description"
          >
            Abbiamo inviato un SMS al numero certificato, contenente il codice temporaneo a 8 cifre (OTP). Inseriscilo
            di seguito per accedere </p>
        </div>
<!--        <div nz-col nzSpan="24" *ngSwitchCase="OtpDeliveryMethod.QrCode">-->
<!--          <p-->
<!--            i18n="@@OTPInput.QrCode.Description"-->
<!--          >-->
<!--            Per confermare l'operazione, inquadra il <b>QR CODE con l'app TSiD abilitato SPID.</b></p>-->
<!--        </div>-->
        <div nz-col nzSpan="24" *ngSwitchCase="OtpDeliveryMethod.EMAIL">
          <p
            i18n="@@OTPInput.Email.Description"
          >
            Abbiamo inviato una e-mail contenente il codice temporaneo a 8 cifre (OTP). Inseriscilo di seguito per
            accedere </p>
        </div>
        <div nz-col nzSpan="24" *ngSwitchCase="OtpDeliveryMethod.APP">
          <p
            i18n="@@OTPInput.OtpApp.Description"
          >
            Apri l'app TSiD SPID ed inserisci il codice numerico da 8 cifre di seguito </p>
        </div>
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf="showForm$ | async">
    <div nz-col nzSpan="24">
      <div nz-row nzJustify="space-between" nzAlign="middle">
        <div nz-col [nzSpan]="inputFormSpan$ | async">
          <form nz-form [formGroup]="form" (ngSubmit)="login()">
            <nz-form-item>
              <nz-form-label nzSpan="24" nzRequired>OTP</nz-form-label>
              <nz-form-control>
                <nz-input-group
                  nzPrefixIcon="number">
                  <input
                    appAutoFocus
                    type="text"
                    nz-input
                    formControlName="otp"
                    tabindex="1"
                    placeholder="OTP"
                  />
                </nz-input-group>
              </nz-form-control>
            </nz-form-item>
          </form>
        </div>
        <div nz-col *ngIf="showRequireNewOtpButton$ | async">
          <ng-container [ngTemplateOutlet]="requireNewOtpTmpl"></ng-container>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!(showForm$ | async)">
    <div nz-col [nzSpan]="24">
      <app-qr-code
        [qrCode]="level2QrCode$ | async"
      ></app-qr-code>
    </div>
  </ng-container>

  <div nz-col nzSpan="24">
    <nz-alert nzType="info" [nzMessage]="messageTmpl" nzShowIcon>
      <ng-template #messageTmpl>
          <p
            class="alert-message"
            i18n="@@OTPInput.Alert.Info.Message"

          >
            <ng-container [ngSwitch]="selectedLevel2OtpGenerator">
              <ng-container
                *ngSwitchCase="OtpDeliveryMethod.SMS"
              >
                Non hai ricevuto il codice OTP? Se entro <b>{{newOtpOnSmsWaitTime}} secondi</b> non l'hai ricevuto, potrai richiederne un altro.
              </ng-container>
              <ng-container
                *ngSwitchCase="OtpDeliveryMethod.EMAIL"
              >
                Non hai ricevuto il codice OTP? Se entro <b>{{newOtpOnEmailWaitTime}} secondi</b> non l'hai ricevuto, potrai richiederne un altro.
              </ng-container>
<!--              <ng-container-->
<!--                *ngSwitchCase="OtpDeliveryMethod.QrCode"-->
<!--              >-->
<!--                Non hai l'app installata? Scaricala dagli store iOS ed Android.-->
<!--              </ng-container>-->
              <ng-container
                *ngSwitchCase="OtpDeliveryMethod.APP"
              >
                Non hai l'app installata? Scaricala dagli store iOS ed Android.
              </ng-container>
            </ng-container>
          </p>
      </ng-template>
    </nz-alert>
  </div>

  <div nz-col nzSpan="24">
    <div nz-row  class="button-wrapper">
      <ng-container *ngIf="showForm$ | async">
        <div nz-col nzFlex="1">
          <ng-container [ngTemplateOutlet]="backButtonTmpl"></ng-container>
        </div>
        <div nz-col nzFlex="1">
          <button
            nz-button
            nzType="primary"
            i18n="@@OtpInput.Next.Button"
            [disabled]="form.invalid"
            (click)="login()"
          >
            Prosegui
          </button>
        </div>
      </ng-container>
      <ng-container *ngIf="!(showForm$ | async)">
        <div nz-col nzSpan="24">
          <ng-container [ngTemplateOutlet]="backButtonTmpl"></ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #backButtonTmpl>
  <button
    nz-button
    nzType="default"
    i18n="@@OtpInput.Back.Button"
    (click)="onBack()"
  >
    Indietro
  </button>
</ng-template>

<ng-template #requireNewOtpTmpl>
  <ng-container *ngIf="timer$ | async as timer"
  >
    <ng-container *ngIf="timer !== 100; else buttonOtpTmpl"
    >
      <nz-progress [nzPercent]="timer" nzType="circle" [nzWidth]="60" [nzFormat]="otpFormatTimer"></nz-progress>
    </ng-container>
  </ng-container>
  <ng-template #buttonOtpTmpl>
    <button
      nz-button nzType="text"
      i18n="@@OtpInput.RequireANewOtp.Button.Text"
      (click)="onNewOtpClick()"
    >
      Richiedi nuovo codice
    </button>
  </ng-template>

</ng-template>
